<template>
  <c-row>
    <c-col col="12">
      <c-card>
        <c-card-header>
          <c-card-title>
            <strong>Operasional</strong>
          </c-card-title>
        </c-card-header>
        <c-card-body>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th style="width: 40px">No</th>
                <th style="width: 110px">Tanggal</th>
                <th>Deskripsi</th>
                <th>Keterangan</th>
                <th style="width: 100px">Debit</th>
                <th style="width: 100px">Kredit</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(d, k) in operations" :key="k">
                <td>
                  <table-number-2 :index="k" :paginate="paginate" />
                </td>
                <td class="center">{{ d.created_at | dateFormat }}</td>
                <td>
                  {{ d.description }}
                  <strong v-if="d.coa_code">
                    <br />
                    {{ d.coa_code }} {{ d.coa_name }}
                  </strong>
                </td>
                <td>
                  {{ d.notes }}
                  <br v-if="d.bank && d.bank != ''" />
                  <span v-if="d.bank && d.bank != ''" class="flag-secondary">{{
                    d.bank
                  }}</span>
                </td>
                <td class="right">
                  {{ d.debit | thousandSeparator }}
                </td>
                <td class="right">
                  {{ d.credit | thousandSeparator }}
                </td>
              </tr>
            </tbody>
          </table>
        </c-card-body>
        <c-card-footer>
          <paginator :paginator="paginate" @change="changePage" />
        </c-card-footer>
      </c-card>
    </c-col>
  </c-row>
</template>
<script>
import { HTTPAUTH } from "../../lib/httplib";
import { showErrorMessage } from "../../lib/helpers";
import Paginator from '../../components/Paginator.vue';
import TableNumber2 from '../../components/TableNumber2.vue';
export default {
  components: {
    Paginator,
    TableNumber2,
  },
  data () {
    return {
      errors: [],
      operation: {
        coa: null,
        amount: 0,
      },
      operations: [],
      paginate: {},
    };
  },
  created () {
    this.getList(1);
  },
  methods: {
    setAmount (k, n) {
      this.operation.amount = n;
    },
    generateData () {
      var data = this.operation;
      if (data.coa) {
        data.coa_id = data.coa.id;
      }
      return data;
    },
    save () {
      HTTPAUTH.post("/api/v1/operating", this.generateData())
        .then(() => {
          this.operation = {
            coa: null,
            amount: 0,
          };
          this.getList(1);
        })
        .catch((eres) => {
          showErrorMessage(eres);
        });
    },
    getList (page) {
      HTTPAUTH.get("/api/v1/operating?size=10&page=" + page)
        .then((res) => {
          this.operations = res.data.data;
          this.paginate = res.data.paginate;
        })
        .catch((eres) => {
          showErrorMessage(eres);
        });
    },
    changePage (p) {
      this.getList(p)
    }
  },
};
</script>